/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DeadlockedBenefit {
  couponId?: number;
  couponName?: string;
  creditCardId?: number;
  creditCardPaymentId?: number;
  dateAuthorized?: Date;
  dateExpired?: Date;
  editionId?: number;
  freebieMessage?: string;
  pendingBillingId?: number;
  personId?: number;
  subscriberId?: number;
  subscriptionId?: number;
  subscriptionTypeId?: number;
}
